'use client';

import { JobUpdateRecord } from '@/lib/types';
import ShareBtn from '../VideoCard/ShareBtn';

interface JobUpdatesListProps {
  records: JobUpdateRecord[];
  sourceLabel?: string;
}

export default function JobUpdatesList({ records, sourceLabel }: JobUpdatesListProps) {

  if (!records.length) {
    return (
      <p className='rounded-lg border border-dashed border-gray-300 bg-white p-4 text-sm text-gray-600'>
        No job updates available currently.
      </p>
    );
  }

  return (
    <section className='space-y-3'>
      {sourceLabel ? (
        <p className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
          Showing {sourceLabel} jobs
        </p>
      ) : null}
      <div className='space-y-3'>
        {records.map((job) => (          
          <article
            key={job.id}
            className='rounded-lg border border-[#168fc426] bg-[#fafbff] p-4 shadow-sm'
          >
            <div className='flex items-start justify-between gap-3'>
              <h3 className='text-lg font-semibold text-gray-900' style={{width:'80%'}}>{job.companyName}</h3>
              <ShareBtn
                shareUrlOnly={true}
                shareLabel='Share Jobs Page'
              />
            </div>
            <div className='mt-3 grid gap-1 text-sm text-gray-600 sm:grid-cols-2 lg:grid-cols-4'>
              <p className='text-xs text-[#0876dd] font-semibold'>Name of the Post</p>
              <p className='text-base text-[#000000] font-semibold'>{job.title}</p>
              <p className='text-xs text-[#0876dd] font-semibold mt-2'>Total Vacancies</p>
              <p className='text-base text-[#000000] font-semibold'>{job.openings || '-'}</p>
              <p className='text-xs text-[#0876dd] font-semibold mt-2'>Initial Pay</p>
              <p className='text-base text-[#000000] font-semibold'> {job.salary || 'Not Disclosed'}</p>
              <p className='text-xs text-[#0876dd] font-semibold mt-2'>Closing Date for Submission of Application</p>
              <p className='text-base text-[#000000] font-semibold'> {job.lastDateForApplication || '-'}</p>
              <p className='text-xs text-[#0876dd] font-semibold mt-2'>Type</p>
              <p className='text-base text-[#000000] font-semibold'>{job.type || '-'}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
